import { useParams } from 'react-router-dom';
import DownloadButton from './DownloadButton';
import { makeLocalDateStr } from '../../utilities/dates';

export default function EmailCard({ emailData }) {
  let { selectName } = useParams();

  const email_headers = [
    { label: 'Email Subject', key: 'email_subject' },
    { label: 'Date', key: 'date_time' },
    { label: 'Document Filepath', key: 's3_prefix' }
  ];

  const fileName = `EmailTracking_${selectName}`;

  return (
    <div
      className='col-xl-1-12'
      style={{ margin: '10px', background: '#1A4565', border: 'double' }}
    >
      <div className='card' style={{ border: 'none', width: '100%' }}>
        <div
          className='card-body'
          style={{ width: '100%', background: 'lightBlue' }}
        >
          <h3 className='card-title' style={{ marginLeft: '10px' }}>
            Email Tracking
          </h3>
          <table>
            <thead>
              <tr>
                <th>Email Subject</th>
                <th>Date</th>
                <th>View</th>
              </tr>
            </thead>
            <tbody>
              {emailData.map((data, idx) => (
                <tr key={idx}>
                  <td style={{ textAlign: 'center' }}>{data.email_subject}</td>
                  <td style={{ textAlign: 'center' }}>
                    {makeLocalDateStr(data.date_time)}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <a
                      // target='_blank'
                      style={{ color: 'blue', textAlign: 'right' }}
                      rel='noreferrer'
                      href={`/fileExplorer?s3_prefix=outreach/emails/${data.email_id}`}
                    >
                      Email (ID-{data.email_id})
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <hr style={{ color: 'grey' }} />
        </div>
      </div>
      <DownloadButton
        new_data={emailData}
        headers={email_headers}
        file={fileName}
      />
    </div>
  );
}
